import type { NotificationPreferencesTranslations } from "../interfaces/notificationPreferences";

export const notificationPreferencesTranslations: NotificationPreferencesTranslations = {
  status_coming_soon: "EM BREVE",
  message_show: "Ver mensagem",
  message_hide: "Ocultar mensagem",

  preview_label: "Pré-visualização",
  preview_verified_title: "Verificado",
  preview_language_note: "As mensagens são enviadas em espanhol",
  preview_footer: "Coloca Payments",

  test_phone_label: "Número para testes",
  test_phone_help:
    "Os testes só chegam a este número. Assim você vê cada mensagem no seu celular antes de ativá-la.",
  send_test_button: "Enviar teste",
  send_test_to: "Chega a {{phone}}",
  send_test_needs_phone: "Digite acima um número para testar este aviso.",
  send_test_sent: "Enviado",
  send_test_placeholder: "Número de telefone",
  send_test_invalid: "Número inválido para o país selecionado",
  send_test_success: "Mensagem de teste enviada por WhatsApp",
  send_test_skipped: "Esse aviso está desativado no serviço de WhatsApp. O teste não foi enviado.",

  update_success: "Preferência atualizada",
  active_types: "Tipos ativos",
};
